export default __webpack_public_path__ + "static/media/iconSearch.115864ab.svg";